// services/sessionFreshness.ts
import { SECURITY_SETTINGS_PATH } from './authNavigation';

/**
 * Better Auth refuses some security changes (adding a passkey, unlinking a
 * sign-in method) from a session older than a day: 403 `SESSION_NOT_FRESH`
 * (ORA-987). Only signing in again helps, so the Security tab says so and
 * offers to sign out, returning there afterwards.
 */
export const SESSION_NOT_FRESH_CODE = 'SESSION_NOT_FRESH';

export const SESSION_NOT_FRESH_MESSAGE =
  'For security, sign in again before changing this.';

/** Where "Sign Out" goes: the sign-in page, then back to Security. */
export const FRESH_SIGN_IN_PATH = `/auth?redirect=${encodeURIComponent(
  SECURITY_SETTINGS_PATH
)}`;

export const isSessionNotFresh = (
  error: { code?: string } | null | undefined
): boolean => error?.code === SESSION_NOT_FRESH_CODE;
